import React from "react";
import "./aboutcontent.css";

const AboutContent = () => {
  return (
    <section className="about-content-section">
      <div className="about-content-wrapper">
        <h2>
          Beauty begins here
          <span className="inline-img">
            <img
              src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=200&q=80"
              alt="beauty"
            />
          </span>
          with passion for you and
          <span className="inline-img">
            <img
              src="https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&w=200&q=80"
              alt="skin"
            />
          </span>
          your skin.
        </h2>

        <p>
          We could not have created this demo without the help of an amazing
          source of content and products. We extend our sincere appreciation to
          Mokosh, Bkind, and Herbivore for generously allowing us to showcase
          their product images on our demo store. Their collaboration has been
          instrumental in creating a visually engaging and informative
          experience for our visitors. We are proud to align with brands that
          share our commitment to quality and innovation. Thank you for the
          opportunity to feature your exceptional products and contribute to a
          more vibrant online shopping experience.
        </p>
      </div>
    </section>
  );
};

export default AboutContent;